import { create } from 'zustand';
import { api } from '@/shared/lib/api';
import { captureError } from '@/shared/lib/monitoring';

interface FeatureAccess {
  key: string;
  name: string;
  has_access: boolean;
}

interface SubscriptionState {
  plan: 'free' | 'premium';
  status: string;
  expires_at: string | null;
  is_premium: boolean;
  features: FeatureAccess[];
  isLoaded: boolean;

  load: () => Promise<void>;
  hasFeature: (key: string) => boolean;
  setPremium: (expires_at: string) => void;
}

export const useSubscriptionStore = create<SubscriptionState>((set, get) => ({
  plan: 'free',
  status: 'active',
  expires_at: null,
  is_premium: false,
  features: [],
  isLoaded: false,

  load: async () => {
    try {
      const data = await api.get<any>('/subscription/status');
      set({
        plan: data.plan,
        status: data.status,
        expires_at: data.expires_at,
        is_premium: data.is_premium,
        features: data.features ?? [],
        isLoaded: true,
      });
    } catch (err) {
      captureError(err, { context: 'subscriptionStore.load' });
      set({ isLoaded: true });
    }
  },

  hasFeature: (key: string) => {
    const { is_premium, features } = get();
    const feature = features.find(f => f.key === key);
    if (feature) return feature.has_access;
    // Fallback: premium users get everything
    return is_premium;
  },

  setPremium: (expires_at: string) => {
    set({ plan: 'premium', is_premium: true, status: 'active', expires_at });
  },
}));
